import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BuildIcon from '@material-ui/icons/Build';
import { ManageProducts_NavLink_To } from '../../Constants/AppBar';

const useStyles = makeStyles(() => ({
	noUnderline: { textDecoration: 'none' },
}));

const manageTxt = 'Manage';

// Manage Product button component.
const ManageProductButton = ({ id, label }) => {
	const classes = useStyles();
	return (
		<Link
			className={classes.noUnderline}
			to={{
				pathname: ManageProducts_NavLink_To + '/' + id,
			}}
			target="_blank"
		>
			<Button color="primary" startIcon={label ? '' : <BuildIcon />}>
				{label ?? manageTxt}
			</Button>
		</Link>
	);
};

export default ManageProductButton;
